import {useSkillzStyle} from '@/app/games/[gid]/_src/SkillzStyleProvider';

type Props = {progress: number};

export default function LoadingBar({progress}: Props) {
  const {themeJSON} = useSkillzStyle();
  const {viewBoxShadowPrimary: shadow, progressBarColor} = themeJSON.sheetStyles || {};
  const boxShadow = shadow
    ? `${shadow?.shadowOffset.width}px ${shadow?.shadowOffset.height}px ${shadow?.shadowRadius}px ${shadow?.shadowColor} ${shadow?.shadowOpacity}`
    : undefined;

  return (
    <div className='absolute z-20 top-0 left-0 w-screen h-1'>
      <div
        className='h-1'
        style={{
          width: `${progress * 100}%`,
          backgroundColor: progressBarColor?.backgroundColor,
          boxShadow,
          transition: 'width 0.3s',
        }}
      />
    </div>
  );
}
